import * as api from '../services/bajajInstantQueue';

export const BAJAJ_CASE_CLAIMED      = 'BAJAJ_CASE_CLAIMED';
export const BAJAJ_QUEUE_LOAD        = 'BAJAJ_QUEUE_LOAD';
export const BAJAJ_QUEUE_UPDATE      = 'BAJAJ_QUEUE_UPDATE';
export const BAJAJ_QUEUE_ERROR       = 'BAJAJ_QUEUE_ERROR';
export const BAJAJ_DOCTOR_STATE_SET  = 'BAJAJ_DOCTOR_STATE_SET';
export const BAJAJ_CALL_STARTED      = 'BAJAJ_CALL_STARTED';

export const loadOpsState = () => async (dispatch) => {
  try {
    const data = await api.getOpsState();
    dispatch({ type: BAJAJ_QUEUE_LOAD, payload: data });
  } catch (err) {
    dispatch({ type: BAJAJ_QUEUE_ERROR, payload: err.message });
  }
};

export const applyOpsUpdate = (payload) => ({
  type: BAJAJ_QUEUE_UPDATE,
  payload,
});

export const doManualAssign = (consultationId, doctorId) => async (dispatch) => {
  await api.manualAssign(consultationId, doctorId);
};

export const loadDoctorState = () => async (dispatch) => {
  try {
    const data = await api.getDoctorState();
    dispatch({ type: BAJAJ_DOCTOR_STATE_SET, payload: data });
  } catch (err) {
    dispatch({ type: BAJAJ_QUEUE_ERROR, payload: err.message });
  }
};

export const changeDoctorStatus = (status) => async (dispatch) => {
  try {
    await api.setDoctorStatus(status);
    dispatch(loadDoctorState());
  } catch (err) {
    dispatch({ type: BAJAJ_QUEUE_ERROR, payload: err.message });
  }
};

export const doStartCall = (consultationId) => async (dispatch) => {
  try {
    const data = await api.startCall(consultationId);
    dispatch({ type: BAJAJ_CALL_STARTED, payload: data });
    return data;
  } catch (err) {
    dispatch({ type: BAJAJ_QUEUE_ERROR, payload: err.message });
    return null;
  }
};

export const doCompleteCall = (consultationId) => async (dispatch) => {
  try {
    await api.completeCall(consultationId);
    dispatch(loadDoctorState());
  } catch (err) {
    dispatch({ type: BAJAJ_QUEUE_ERROR, payload: err.message });
  }
};

export const doClaimCase = (consultationId) => async (dispatch) => {
  try {
    const data = await api.claimCase(consultationId);
    if (data && data.status === 'success') {
      dispatch({ type: BAJAJ_CALL_STARTED, payload: data });
    }
    return data;
  } catch (err) {
    dispatch({ type: BAJAJ_QUEUE_ERROR, payload: err.message });
    return null;
  }
};

export const setOpsDoctorStatus = (doctorId, status) => async (dispatch) => {
  try {
    await api.setOpsDoctorStatus(doctorId, status);
    dispatch(loadOpsState());
  } catch (err) {
    dispatch({ type: BAJAJ_QUEUE_ERROR, payload: err.message });
  }
};

export const doGetVmerLink = (proposalNumber) => async (dispatch) => {
  try {
    const data = await api.getVmerLink(proposalNumber);
    if (data && data.status === 'success') {
      dispatch(loadOpsState());
    }
    return data;
  } catch (err) {
    dispatch({ type: BAJAJ_QUEUE_ERROR, payload: err.message });
    return { status: 'failure', errorMessage: err.message };
  }
};

export const doRegisterInstantCase = (payload) => async (dispatch) => {
  try {
    const data = await api.registerInstantCase(payload);
    if (data && (data.status === 'success' || data.status === 'duplicate')) {
      dispatch(loadOpsState());
    }
    return data;
  } catch (err) {
    dispatch({ type: BAJAJ_QUEUE_ERROR, payload: err.message });
    return { status: 'failure', errorMessage: err.message };
  }
};
